import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL;

const getCategories = () => {
  return axios.get(`${API_URL}/categories/`);
};

const getCategoriesWithGroup = () => {
  return axios.get(`${API_URL}/categories/cat`);
};
const getCategory = (id) => {
  return axios.get(`${API_URL}/categories/find/${id}`);
};

export { getCategories, getCategory, getCategoriesWithGroup };
